import { render, staticRenderFns } from "./QuickPreview.vue?vue&type=template&id=8f0174a2"
import script from "./QuickPreview.vue?vue&type=script&lang=js"
export * from "./QuickPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports